
import { useEffect, useRef, useState } from "react"

import { useDispatch } from "react-redux";

import { useNavigate, useParams } from "react-router";

import { Box, Paper, Tabs, Tab, Grid, Button, Card, Typography, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, FormControl, InputLabel, Select, MenuItem, Stack, Avatar } from "@mui/material"

import { DocumentEditorContainerComponent, CustomToolbarItemModel, ToolbarItem, Toolbar } from "@syncfusion/ej2-react-documenteditor";
import { DropDownButton, ItemModel } from "@syncfusion/ej2-react-splitbuttons";

import moment from "moment";

import { DefaultDocumentEditor } from "../../../helpers/DefaultDocumentEditor";
import { TabProps, TabPanel } from "../../../helpers/TabPanel"

import { openSnackbar } from "../../../store/slices/SnackbarSlice";

import { DialogActionsStyle, DialogContentStyle } from "../../../styles/DialogStyle";

import { Layout } from "../../../components/Layout"
import { BoxInformacionExpediente } from "../../../components/BoxInformacionExpediente"
import { CircularProgressIndicator } from "../../../components/CircularProgressIndicator"
import { BoxHeaderInformacion } from "../../../components/BoxHeaderInformacion"
import { BoxProcesoCancelado } from "../../../components/BoxProcesoCancelado";
import { BoxProcesoTerminado } from "../../../components/BoxProcesoTerminado";
import { BoxProcesoNoEncontrado } from "../../../components/BoxProcesoNoEncontrado";

import { Anexos } from "../ui/Anexos";
import { Asistentes } from "../ui/Asistentes";
import { Notificacion } from "../ui/Notificacion";
import { AcordarPromociones } from "../ui/AcordarPromociones";
import { InformacionAudiencia } from "../ui/InformacionAudiencia";

import { ObtenerPlantilla, ObtenerPlantillaDetalle } from "../../../connections/admin/PlantillaConnection";
import { ActualizarActaAudiencia, ActualizarEstatusAudiencia, DetalleAudiencia } from "../../../connections/audiencias/AudienciaConnection";

import { AnexoProps } from "../../../interfaces/comun/AnexoInterface";
import { PlantillaProps } from "../../../interfaces/admin/PlantillaInterface";
import { NotificacionesProps } from "../../../interfaces/notificaciones/NotificacionesInterface";
import { ActualizarActaAudienciaParams, AsistenteProps, AudienciaProps, defaultAudiencia, PromocionesProps } from "../../../interfaces/audiencias/AudienciaInterface";

DocumentEditorContainerComponent.Inject(Toolbar);

const defaultDocument = DefaultDocumentEditor();

interface ItemModelModif extends ItemModel {
    value?: string;
}

export const ElaborarActaAudienciaPage = () => {

    const { Id } = useParams();

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [loading, setLoading] = useState( true );
    const [loadingFinalizar, setLoadingFinalizar] = useState( false );
    const [loadingGuardar, setLoadingGuardar] = useState( false );

    const syncfusionEditor = useRef<DocumentEditorContainerComponent | null>( null );
    const contenidoRef = useRef( '' );

    const dropCampos = useRef<DropDownButton>( null );

    const [plantilla, setPlantilla] = useState( 0 );
    const [plantillasArray, setPlantillasArray] = useState<PlantillaProps[]>( [] );

    const [value, setValue] = useState( 0 );

    const [editorReady, setEditorReady] = useState( false );

    const [audiencia, setAudiencia] = useState<AudienciaProps>( defaultAudiencia );

    const [procesoTerminado, setProcesoTerminado] = useState( false );
    const [procesoCancelado, setProcesoCancelado] = useState( false );
    const [procesoNoEncontrado, setProcesoNoEncontrado] = useState( false );
    const [mensajeFinalizacion, setMensajeFinalizacion] = useState( '' );
    const [mensajeAsignacion, setMensajeAsignacion] = useState( '' );

    const [openDialogConfirmacionFinalizar, setOpenDialogConfirmacionFinalizar] = useState(false);
    const [openDialogConfirmacionRegresar, setOpenDialogConfirmacionRegresar] = useState(false);

    const [asistentes, setAsistentes] = useState<AsistenteProps[]>( [] );
    const [notificaciones, setNotificaciones] = useState<NotificacionesProps[]>( [] );
    const [anexos, setAnexos] = useState<AnexoProps[]>( [] );
    const [promociones, setPromociones] = useState<PromocionesProps[]>( [] );

    let Toolbar: (CustomToolbarItemModel | ToolbarItem)[] = [
        'New',
        'Open',
        'Separator',
        'Undo',
        'Redo',
        'Separator',
        'Image',
        'Table',
        'Separator',
        'Header',
        'Footer',
        'Separator',
        {
            tooltipText: 'Atajos',
            text: 'Atajos',
            id: 'dropItem',
            prefixIcon: "e-icons e-drop-down",
        }
    ];

    const handleChange = (_: React.SyntheticEvent, newValue: number) => {

        if ( value === 0 && newValue !== 0 ) {

            const serialized = syncfusionEditor.current?.documentEditor.serialize() ?? '';

            contenidoRef.current = serialized;
            setEditorReady( false );
        }

        setValue( newValue );
    }

    const Guardar = async () => {

        const serialized = syncfusionEditor.current?.documentEditor.serialize() ?? '';

        const params: ActualizarActaAudienciaParams = {
            idAudiencia: Id ?? '',
            idPlantilla: plantilla,
            contenido:   serialized,
            observaciones: '',
        }

        contenidoRef.current = serialized;

        return await ActualizarActaAudiencia( params );
    }

    const handleGuardar = async () => {

        setLoadingGuardar( true );

        await Guardar().then(resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    dispatch( openSnackbar({ message: message, variant: 'success' }) );
                    setLoadingGuardar( false );

                }
                else {

                    dispatch( openSnackbar({ message: message, variant: 'error' }) );
                    setLoadingGuardar( false );

                }

            }, 700);

        });

    }

    const handleActualizarEstatus = async ( idEstatus: number ) => {

        setLoadingFinalizar( true );

        const { success: successGuardar, message: messageGuardar } = await Guardar();

        if ( !successGuardar ) {

            setTimeout(() => {

                dispatch(openSnackbar({ message: messageGuardar, variant: 'error' }));
                setLoadingFinalizar( false );

            }, 700);

            return;
        }
        await ActualizarEstatusAudiencia({ idAudiencia: Id ?? '', idEstatus }).then( resp => {

            const { success, message, asignadoMismoUsuario, usuarioAsignado } = resp;

            if ( success ) {

                setTimeout(() => {

                    if ( idEstatus === 30 ) {

                        if ( asignadoMismoUsuario ) {

                            navigate(`/gestionar-audiencia/celebrar-audiencia/${ Id ?? ''}`);
                            setLoadingFinalizar( false );

                        } else {

                            setProcesoTerminado( true );
                            setMensajeAsignacion(`La siguiente actividad se asignó a ${ usuarioAsignado }`);
                            setLoadingFinalizar( false );

                        }

                    }
                    else if ( idEstatus === 33 ) {

                        if ( asignadoMismoUsuario ) {

                            navigate(`/gestionar-audiencia/validar-acta/${ Id ?? '' }`);
                            setLoadingFinalizar( false );

                        }
                        else {

                            setProcesoTerminado( true );
                            setMensajeAsignacion(`La siguiente actividad se asignó a ${ usuarioAsignado }`);

                            setLoadingFinalizar( false );

                        }
                    }

                }, 700);

            }
            else {

                setTimeout(() => {

                    dispatch( openSnackbar({ message: message, variant: 'error' }) );
                    setLoadingFinalizar(false);

                }, 700);

            }

        });

    }

    //---------------------------------------------- funciones para plantilla ----------------------------------------------------------

    const handleObtenerPlantilla = async ( id: number ) => {

        setPlantilla( id );

        await ObtenerPlantillaDetalle( id ).then( resp => {

            const { idPlantilla, contenido, } = resp;

            if ( idPlantilla !== 0 ) {

                if ( !( /<\/?[a-z][\s\S]*>/.test(contenido) ) ) {

                    const contentSetValues = reemplaceData( contenido );

                    syncfusionEditor.current?.documentEditor.open( contentSetValues );

                }
                else if ( /<\/?[a-z][\s\S]*>/.test(contenido) ) {

                    const contenidoParser = contenido.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').replace(/&/g, "").replace(/acute;/g, "") ?? "";

                    const contentSetValues = reemplaceData( contenidoParser );

                    syncfusionEditor.current?.documentEditor.open( defaultDocument );

                    syncfusionEditor.current?.documentEditor.editor.insertText( contentSetValues );
                }
                else {
                    syncfusionEditor.current?.documentEditor.open( defaultDocument );
                }

            }

        });

    }

    const reemplaceData = ( contenido: string ) => {

        let contentSetValues = contenido.replaceAll('[Juez]', audiencia.juez ?? "")

        if ( audiencia.expediente.idExpediente !== 0 ) {

            contenido
                .replaceAll('[Numero_Expediente]', audiencia.expediente?.numeroExpediente ?? '')
                .replaceAll('[Numero_Folio]', audiencia.expediente?.numeroFolio ?? '')
                .replaceAll('[Tipo_juicio]', audiencia.expediente?.tipoJuicio ?? '')
                .replaceAll('[Juez_Expediente]', audiencia.expediente?.juez ?? '')
                .replaceAll('[Juzgado_Origen]', audiencia.expediente?.juzgadoOrigen ?? '')
                .replaceAll('[Actores]', audiencia.expediente.actores.join(', ') )
                .replaceAll('[Demandados]', audiencia.expediente.demandados.join(', ') )
                .replaceAll('[Fecha_Expediente]', audiencia.expediente.fecha ? moment( audiencia.expediente.fecha ).format('DD-MM-YYYY') : '');

        }

        return contentSetValues;
    }

    //--------------------------------------------- funciones para el editor de text --------------------------------------------------

    const handleEditorCreated = () => {
        setEditorReady( true );
    };

    useEffect(() => {

        if ( value === 0 && !loading && editorReady && syncfusionEditor.current ) {

            syncfusionEditor.current.documentEditor.open( contenidoRef.current || DefaultDocumentEditor() );
            syncfusionEditor.current.documentEditorSettings.showRuler = true;
            syncfusionEditor.current.documentEditor.pageOutline = '#D0D0D0';

            dropCampos.current?.appendTo('#dropItem');

        }

    }, [ value, loading, editorReady ]);

    //----------------------------------------------------------------------------------------------------------------------------------

    useEffect(() => {

        async function Obtener() {

            await ObtenerPlantilla({
                idAutoridad: 6,
                idTipoAcuerdo: 8,
                idSubTipoAcuerdo: 0,
                idTipoNotificacion: 0
            }).then( resp => { setPlantillasArray( resp ); });

        }

        Obtener();

    }, [])

    useEffect(() => {

        async function Obtener() {

            setLoading( true );

            await DetalleAudiencia( Id ?? '' ).then(resp => {

                setTimeout(() => {

                    const { success } = resp;

                    if ( success ) {

                        setAudiencia( resp );
                        setAsistentes( resp.asistentes );
                        setNotificaciones( resp.notificaciones );
                        setAnexos( resp.anexos );
                        setPromociones( resp.promociones );

                        const mkItem = ( text: string, id: string, value: string ): ItemModelModif[] =>
                            [{ text, id, iconCss: 'e-icons e-bookmark', value }, { separator: true }];
                        const joinNames = ( arr: string[] ) => arr.join(', ');
                        const fmtDate = ( d?: Date ) => d ? moment( d ).format('DD-MM-YYYY') : '';
                        const fmtTime = ( d?: Date ) => d ? moment( d ).format('HH:mm') : '';

                        let items: ItemModelModif[] = [
                            ...mkItem('Fecha Actual', '1', '[Fecha_Actual]'),
                            ...mkItem('Tipo de Audiencia', '2', resp.tipoAudiencia),
                            ...mkItem('Juez', '3', resp.juez),
                            ...mkItem('Secretario', '4', resp.secretario),
                        ];

                        if ( resp.fechaAudiencia.fechaInicio ) {
                            items.push(
                                ...mkItem('Fecha de Audiencia', '5', fmtDate( resp.fechaAudiencia.fechaInicio )),
                                ...mkItem('Hora de Audiencia', '6', `${ fmtTime( resp.fechaAudiencia.fechaInicio ) } - ${ fmtTime( resp.fechaAudiencia.fechaFin ) }`),
                                ...mkItem('Sala', '7', resp.fechaAudiencia.sala),
                            );
                        }

                        if ( resp.idExpediente !== 0 ) {

                            const { expediente: e } = resp;

                            items.push(
                                ...mkItem('Número de Expediente', '8', e.numeroExpediente),
                                ...mkItem('Tipo de Juicio', '9', e.tipoJuicio),
                                ...mkItem('Juzgado Origen', '10', e.juzgadoOrigen),
                                ...mkItem('Actor(es)', '11', joinNames( e.actores )),
                                ...mkItem('Demandado(s)', '12', joinNames( e.demandados )),
                            );

                            if ( e.numeroFolio ) items.push(...mkItem('Número de Folio', '13', e.numeroFolio));

                        }

                        if ( resp.asistentes.length > 0 ) {
                            const cadenaAsistentes = resp.asistentes.map( ({ persona, tipoParte }) => `${ persona } (${ tipoParte })` ).join(', ');
                            items.push(...mkItem('Asistentes', '14', cadenaAsistentes));
                        }

                        if ( items[items.length - 1]?.separator ) { items.pop(); }

                        dropCampos.current = new DropDownButton({
                            items: items,
                            beforeItemRender: (data: ItemModelModif) => {
                                return `<div>
                                            <span class="e-menu-icon ${data.iconCss}"></span>
                                            <span class="custom-class" >${data.text}</span>
                                        </div>`;
                            },
                            select: (args) => syncfusionEditor.current?.documentEditor.editor.insertText( args?.item.value ?? "" ),
                        },);

                        contenidoRef.current = resp.contenido;

                        if ( resp.idEstatus === 3 ) {

                            setMensajeFinalizacion('No se tienen actividades pendientes para este trámite');
                            setProcesoTerminado( true );
                            setLoading( false );

                        }
                        else if ( resp.idEstatus === 4 ) {

                            setProcesoCancelado( true );
                            setLoading( false );

                        }
                        else if ( !resp.asignadoMismoUsuario ) {

                            setMensajeAsignacion(`La siguiente actividad se asignó a ${ resp.usuarioAsignado }`);
                            setProcesoTerminado( true );
                            setLoading( false );

                        }
                        else if ( resp.asignadoMismoUsuario && resp.idEstatus !== 31 ) {

                            setMensajeAsignacion('La siguiente actividad se encuentra en tu bandeja');
                            setProcesoTerminado( true );
                            setLoading( false );

                        }
                        else if ( resp.asignadoMismoUsuario && resp.idEstatus === 31 ) {
                            setLoading( false );
                        }

                    }
                    else {

                        setProcesoNoEncontrado( true );
                        setLoading( false );

                    }

                }, 700);

            });

        }

        if ( Id ) {
            Obtener();
        }

    }, [ Id ])

    return (
        <Layout breadcrumbs={ [{ text: 'Gestionar audiencia' }, { text: 'Elaborar acta de audiencia' }] } backgroundPaper={ ( procesoTerminado || procesoCancelado || procesoNoEncontrado ) }>

            {
                loading
                ?
                    <Box component={ Paper } height={ '70vh' } textAlign={ 'center' } alignContent={ 'center' } alignItems={ 'center' }>
                        <CircularProgressIndicator />
                    </Box>
                :
                    ( procesoTerminado || procesoCancelado || procesoNoEncontrado )
                    ?
                        procesoNoEncontrado
                        ?
                            <BoxProcesoNoEncontrado />
                        :
                            procesoCancelado
                            ?
                                <BoxProcesoCancelado />
                            :
                                <BoxProcesoTerminado message={ mensajeFinalizacion } messageAssing={ mensajeAsignacion } processEnd={ audiencia.idEstatus === 3 } />
                        :
                            <>

                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>

                                    <Tabs value={ value } onChange={ handleChange }>

                                        <Tab label="Acta de audiencia" {...TabProps(0)} />
                                        <Tab label="Información de la audiencia" {...TabProps(1)} />
                                        <Tab label="Asistentes en la audiencia" {...TabProps(2)} />
                                        <Tab label="Notificación" {...TabProps(3)} />
                                        <Tab label="Anexo(s)" {...TabProps(4)} />
                                        <Tab label="Acordar promociones" {...TabProps(5)} />
                                        <Tab label="Información del expediente" {...TabProps(6)} />

                                    </Tabs>

                                </Box>

                                <TabPanel value={ value } index={ 0 }>

                                    <Box p={ 4 } component={ Paper }>

                                        <BoxHeaderInformacion numeroSeguimiento={ `GAU-${ audiencia.idAudiencia }` } fecha={ audiencia?.fecha ?? new Date() } juez={ audiencia.juez } />

                                        <Grid container spacing={ 3 } mt={ 3 }>

                                            <Grid size={{ md: 12, xs: 12 }}>

                                                <FormControl fullWidth>

                                                    <InputLabel>Plantilla</InputLabel>

                                                    <Select
                                                        label={ 'Plantilla' }
                                                        value={ plantilla }
                                                        onChange={ (e) => handleObtenerPlantilla( e.target.value ) }
                                                    >
                                                        <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                        {
                                                            plantillasArray
                                                            .map(({ idPlantilla, descripcion }) => (
                                                                <MenuItem key={ idPlantilla } value={ idPlantilla }>{ descripcion }</MenuItem>
                                                            ))
                                                        }

                                                    </Select>

                                                </FormControl>

                                            </Grid>

                                            <Grid size={{ md: 12, xs: 12 }}>

                                                <DocumentEditorContainerComponent
                                                    key={ 'DocumentEditorContainer' }
                                                    serviceUrl={ process.env.REACT_APP_URL_SERVICE_DOCUMENT_EDITOR ?? '' }
                                                    height={ '650' }
                                                    ref={ syncfusionEditor }
                                                    enableToolbar={ true }
                                                    showPropertiesPane={ false }
                                                    toolbarItems={ Toolbar }
                                                    autoResizeOnVisibilityChange={ false }
                                                    created={ handleEditorCreated }
                                                >
                                                </DocumentEditorContainerComponent>

                                            </Grid>

                                            {
                                                audiencia.observaciones
                                                &&
                                                    <Grid size={ { xs: 12, md: 12 } }>

                                                        <Card sx={{ p: 2 }}>

                                                            <Typography variant="h6" sx={{ mb: 2 }}>
                                                                Observaciones
                                                            </Typography>

                                                            <Stack spacing={ 2 }>

                                                                {
                                                                    audiencia.usuarioObservaciones.map( ( { usuario, puesto, observacion, fecha }, i ) => (

                                                                        <Box key={ i } sx={ { display: "flex", gap: 1.5, alignItems: "flex-start" } }>

                                                                            <Avatar
                                                                                sx={{
                                                                                    width: 36,
                                                                                    height: 36,
                                                                                    fontSize: 12,
                                                                                    fontWeight: 500,
                                                                                    bgcolor: (theme) => theme.palette.primary.main,
                                                                                    color: 'white',
                                                                                }}
                                                                            >
                                                                                { usuario.split(" ").slice(0, 2).map(n => n[0]).join("") }
                                                                            </Avatar>

                                                                            <Box
                                                                                sx={{
                                                                                    flex: 1,
                                                                                    bgcolor: "action.hover",
                                                                                    border: "0.5px solid",
                                                                                    borderColor: "divider",
                                                                                    borderRadius: "0 15px 15px 15px",
                                                                                    px: 2,
                                                                                    py: 1.25,
                                                                                }}
                                                                            >

                                                                                <Typography variant={ 'subtitle2' } fontWeight={ 500 }>
                                                                                    { usuario }
                                                                                </Typography>

                                                                                <Typography variant="body2" color="text.secondary" sx={{ fontSize: 14 }}>
                                                                                    { puesto ? `${ puesto }` : '' }
                                                                                </Typography>

                                                                                <Typography variant="body2" color="text.secondary" sx={{ my: 1, lineHeight: 1.5 }}>
                                                                                    { observacion }
                                                                                </Typography>

                                                                                {
                                                                                    fecha
                                                                                    &&
                                                                                        <Typography variant="caption" color="text.disabled" sx={{ mt: 0.75, display: "block" }}>
                                                                                            {  fecha ? moment( fecha ).format('DD-MM-YYYY hh:mm a') : '' }
                                                                                        </Typography>

                                                                                }

                                                                            </Box>

                                                                        </Box>

                                                                    ))
                                                                }

                                                            </Stack>

                                                        </Card>

                                                    </Grid>
                                            }

                                            <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>

                                                <Grid container spacing={ 3 }>

                                                    <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'right' }}>

                                                        <Button
                                                            fullWidth
                                                            color='secondary'
                                                            onClick={ () => setOpenDialogConfirmacionRegresar( true ) }
                                                        >
                                                            Regresar a celebrar audiencia
                                                        </Button>

                                                    </Grid>

                                                    <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'right' }}>

                                                        <Button
                                                            fullWidth
                                                            color='secondary'
                                                            variant="outlined"
                                                            loading={ loadingGuardar }
                                                            onClick={ handleGuardar }
                                                        >
                                                            Guardar
                                                        </Button>

                                                    </Grid>

                                                    <Grid size={{ md: 4, xs: 12 }} style={{ textAlign: 'left' }}>

                                                        <Button
                                                            fullWidth
                                                            color='primary'
                                                            variant="contained"
                                                            onClick={ () => setOpenDialogConfirmacionFinalizar( true ) }
                                                        >
                                                            Finalizar
                                                        </Button>

                                                    </Grid>

                                                </Grid>

                                            </Grid>

                                        </Grid>

                                    </Box>

                                </TabPanel>

                                <TabPanel value={ value } index={ 1 }>

                                    <Box p={ 4 } component={ Paper }>

                                        <InformacionAudiencia
                                            audiencia={ audiencia }
                                            edit={ false }
                                        />

                                    </Box>

                                </TabPanel>

                                <TabPanel value={ value } index={ 2 }>

                                    <Asistentes
                                        audiencia={ audiencia }
                                        asistentes={ asistentes }
                                        setAsistentes={ setAsistentes }
                                        partes={ audiencia.expediente.partes }
                                        edit={ false }
                                    />

                                </TabPanel>

                                <TabPanel value={ value } index={ 3 }>

                                    <Notificacion
                                        audiencia={ audiencia }
                                        notificaciones={ notificaciones }
                                        setNotificaciones={ setNotificaciones }
                                        edit={ false }
                                    />

                                </TabPanel>

                                <TabPanel value={ value } index={ 4 }>

                                    <Anexos
                                        audiencia={ audiencia }
                                        anexos={ anexos }
                                        setAnexos={ setAnexos }
                                        edit={ false }
                                    />

                                </TabPanel>

                                <TabPanel value={ value } index={ 5 }>

                                    <AcordarPromociones
                                        audiencia={ audiencia }
                                        promociones={ promociones }
                                        setPromociones={ setPromociones }
                                        edit={ false }
                                    />

                                </TabPanel>

                                <TabPanel value={ value } index={ 6 }>

                                    <BoxInformacionExpediente expediente={ audiencia.expediente } />

                                </TabPanel>

                                <Dialog
                                    fullWidth
                                    maxWidth='sm'
                                    open={ openDialogConfirmacionRegresar }
                                    onClose={ () => {} }
                                >

                                    <DialogTitle>
                                        Confirmación
                                    </DialogTitle>

                                    <DialogContent sx={ DialogContentStyle }>

                                        <DialogContentText>
                                            ¿Desea regresar a la celebración de audiencia?
                                        </DialogContentText>

                                    </DialogContent>

                                    <DialogActions sx={ DialogActionsStyle }>

                                        <Button color="secondary" disabled={ loadingFinalizar } onClick={ () => setOpenDialogConfirmacionRegresar( false ) }> Cancelar </Button>
                                        <Button variant='contained' loading={ loadingFinalizar } onClick={ () => handleActualizarEstatus( 30 ) }> Aceptar </Button>

                                    </DialogActions>
                                </Dialog>

                                <Dialog
                                    fullWidth
                                    maxWidth='sm'
                                    open={ openDialogConfirmacionFinalizar }
                                    onClose={ () => {} }
                                >

                                    <DialogTitle>
                                        Confirmación
                                    </DialogTitle>

                                    <DialogContent sx={ DialogContentStyle }>

                                        <DialogContentText>
                                            ¿Desea finalizar la elaboración de la acta de audiencia?
                                        </DialogContentText>

                                    </DialogContent>

                                    <DialogActions sx={ DialogActionsStyle }>

                                        <Button color="secondary" disabled={ loadingFinalizar } onClick={ () => setOpenDialogConfirmacionFinalizar( false ) }> Cancelar </Button>
                                        <Button variant='contained' loading={ loadingFinalizar } onClick={ () => handleActualizarEstatus( 33 ) }> Aceptar </Button>

                                    </DialogActions>

                                </Dialog>

                            </>
            }

        </Layout>
    )
}
